import React from 'react';
import { Link } from 'react-router-dom';
import bdgriffinwhite from '../../static/img/bd-griffin-white.png';
import bdgriffin from '../../static/img/bd-griffin.png';
import HeaderLinks from './HeaderLinks';
import MobileNav from './MobileNav';

const Header = props => {
  return (
    <header className="transparent">
      <div className="container-fluid">
        <Link className="logo" to="/">
          <img src={bdgriffin} alt="BD Griffin" />
        </Link>
        <Link className="logo" to="/">
          <img src={bdgriffinwhite} alt="BD Griffin" />
        </Link>
        <HeaderLinks />
        <MobileNav />
      </div>
    </header>
  );
};

export default Header;
